import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bf-kpis" }
const _hoisted_2 = { class: "bf-kpi__label" }
const _hoisted_3 = { class: "bf-kpi__caption" }
const _hoisted_4 = { class: "bf-card bf-kpi bf-kpi--plan" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressCircle = _resolveComponent("ProgressCircle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats, (stat) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "bf-card bf-kpi",
        key: stat.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass(["bf-kpi__dot", `bf-kpi__dot--${_ctx.dotMap[stat.class] || 'brand'}`])
          }, null, 2),
          _createTextVNode(" " + _toDisplayString(stat.title), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["bf-kpi__value", { 'bf-kpi__value--err': stat.class === 'bg3' }])
        }, _toDisplayString(stat.number), 3),
        _createElementVNode("div", _hoisted_3, _toDisplayString(stat.description), 1)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ProgressCircle, { value: _ctx.planConsumption }, null, 8, ["value"]),
      _cache[0] || (_cache[0] = _createElementVNode("div", null, [
        _createElementVNode("div", { class: "bf-kpi__label" }, "Consumo de Integrações"),
        _createElementVNode("div", { class: "bf-kpi__caption" }, "(Percentual)")
      ], -1))
    ])
  ]))
}